module.exports = __webpack_public_path__ + "static/media/00_1440.38a8ecd5.jpg";